<template>
    <BaseButton theme="primary" :size="size" class="shrink-0" :disabled="loading">
        <!-- Label and spinner share one grid cell so the button keeps its width and the evidence chips beside it don't reflow while the chat starts. -->
        <span class="grid place-items-center">
            <span class="col-start-1 row-start-1 text-pretty" :class="{ invisible: loading }">{{ label ?? t("insights.diveDeeper") }}</span>
            <LoadingSpinner v-if="loading" class="col-start-1 row-start-1 size-4" aria-hidden="true" />
        </span>
        <span role="status" aria-live="polite" aria-atomic="true" class="sr-only">{{ loading ? t("insights.startingChat") : "" }}</span>
    </BaseButton>
</template>

<script setup lang="ts">
import BaseButton, { type ButtonSize } from "~vue/components/BaseButton.vue";
import LoadingSpinner from "~vue/icons/LoadingSpinner.vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

withDefaults(defineProps<{ loading: boolean; label?: string; size?: ButtonSize }>(), {
    size: "md",
});
</script>
